import type { FeatureLike } from 'ol/Feature';
import { Point } from 'ol/geom';
import { transform } from 'ol/proj';
import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Style,
  Text,
} from 'ol/style';

import type { NamedLatLonCoordinate } from '@nora-monorepo/shared';
import { NoraSupportedCoordinateFormats } from '@nora-monorepo/shared';

export function spotStyleFunction(feature: FeatureLike): Style[] {
  const coordinates = feature.get('coordinates') as
    | NamedLatLonCoordinate[]
    | undefined;
  if (coordinates && Array.isArray(coordinates)) {
    const styles: Style[] = [];
    for (const coord of coordinates) {
      const isOrigin = coord.name === 'Origin';
      const label = coord.name ?? '';
      const olCoordinate = transform(
        [coord.longitude, coord.latitude],
        NoraSupportedCoordinateFormats.WGS84,
        NoraSupportedCoordinateFormats.WEB_MERCATOR,
      );

      // Create a style for this point
      styles.push(
        new Style({
          geometry: new Point(olCoordinate),
          image: new CircleStyle({
            radius: 6,
            fill: new Fill({ color: isOrigin ? '#668599' : '#3E5E74' }),
            stroke: new Stroke({
              color: isOrigin ? '#8EA7B8' : '#4D7189',
              width: 2,
            }),
          }),
          text: new Text({
            text: label,
            font: '12px Arial, sans-serif',
            fill: new Fill({ color: 'black' }),
            stroke: new Stroke({ color: 'white', width: 3 }),
            offsetY: -18,
          }),
        }),
      );
    }

    // Add an invisible style for the actual feature geometry (polygon)
    // This ensures the feature is properly detected by OpenLayers but not visually rendered
    styles.push(
      new Style({
        fill: new Fill({ color: 'transparent' }),
        stroke: new Stroke({ color: 'transparent', width: 0 }),
      }),
    );

    return styles;
  }

  return [];
}
